import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const SET_SELECTED_PRODUCT_SKU = 'SET_SELECTED_PRODUCT_SKU'
const SET_SELECTED_PRODUCT_NAME = 'SET_SELECTED_PRODUCT_NAME'
const SET_SELECTED_ITEMS_TOTAL = 'SET_SELECTED_ITEMS_TOTAL'
const SET_SELECTED_SUBSCRIPTION_SKU = 'SET_SELECTED_SUBSCRIPTION_SKU'
const CLEAR_ALL = 'CLEAR_ALL'

export default new Vuex.Store({
  state: {
    selectedProductSKU: null,
    selectedProductName: null,
    selectedItemsTotal: null,
    selectedSubscriptionSKU: null,
  },
  getters: {
    selectedProductSKU: state => {
      return state.selectedProductSKU;
    },
    selectedProductName: state => {
      return state.selectedProductName;
    },
    selectedItemsTotal: state => {
      return state.selectedItemsTotal;
    },
    selectedSubscriptionSKU: state => {
      return state.selectedSubscriptionSKU;
    }
  },
  mutations: {
    [SET_SELECTED_PRODUCT_SKU] (state, productSKU) {
      state.selectedProductSKU = productSKU;
    },
    [SET_SELECTED_PRODUCT_NAME] (state, productName) {
      state.selectedProductName = productName;
    },
    [SET_SELECTED_ITEMS_TOTAL] (state, itemsTotal) {
      state.selectedItemsTotal = itemsTotal;
    },
    [SET_SELECTED_SUBSCRIPTION_SKU] (state, subscriptionSKU) {
      state.selectedSubscriptionSKU = subscriptionSKU;
    },
    [CLEAR_ALL] (state) {
      state.selectedProductSKU = null;
      state.selectedProductName = null;
      state.selectedItemsTotal = null;
      state.selectedSubscriptionSKU = null;
    }
  },
  actions: {
    setSelectedProductSKU({commit}, value) {
      commit(SET_SELECTED_PRODUCT_SKU, value);
    },
    setSelectedProductName({commit}, value) {
      commit(SET_SELECTED_PRODUCT_NAME, value);
    },
    setSelectedItemsTotal({commit}, value) {
      commit(SET_SELECTED_ITEMS_TOTAL, value);
    },
    setSelectedSubscriptionSKU({commit}, value) {
      commit(SET_SELECTED_SUBSCRIPTION_SKU, value);
    },
    setClearAll({commit}) {
      commit(CLEAR_ALL);
    },
    
  },
})


// WEBPACK FOOTER //
// ./src/store/index.js